import ApiClient from "../helpers/ApiClient";

const documentoRoute = (uid, params) =>
  ApiClient.apiClientDef.get(`documento/${uid}`, {
    params,
    responseType: "arraybuffer",
  });

const CommonsApiClient = {
  documentoRoute,
};
export default CommonsApiClient;
